// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportErrorPageContainer_root__3r_bc"};